export enum GenericLookupSelectionType {
  Checkbox,
  Combobox,
  Radio,
  Dropdown,
}
